// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"i3-z","colorTextValue":"j3-z","swatches":"k3-z","collapseLink":"l3-z","isCollapsed":"m3-z","dropdown":"n3-z","disabled":"o3-z"};